<template>
    <login-container>
        <login-window>
            <login-banner :subTitle="`${t_sso_at} ${inner_apps[app_key]?.['name']}`" />

            <div v-if="inner_session.hasOwnProperty('success')">
                <div class=" " >
                    <h3>{{ t_success }}></h3>
                </div>
            </div>
            <div v-else-if="inner_session.hasOwnProperty('activated')">
                <div class=" ">
                    <h3>{{ t_activated }}></h3>
                </div>
            </div>
            <div v-else-if="inner_session.hasOwnProperty('activatedPreviously')">
                <div class=" ">
                    <h3>{{ t_activated_previously }}></h3>
                </div>
            </div>
            <login-form v-else id="form-register" :url="url + '/register-sso/' + app_key">
                <slot></slot>
                <div :class="['form-group', inner_errors.hasOwnProperty('firstname') ? ' has-error' : '']">
                    <input type="text" name="firstname" class="form-control " :placeholder="t_first_name" required v-model="firstname">
                    <span v-if="inner_errors.hasOwnProperty('firstname')" class="help-block ">
                    <strong>{{ inner_errors['firstname'] }}</strong>
                </span>
                </div>
                <div :class="['form-group', inner_errors.hasOwnProperty('lastname') ? ' has-error' : '']">
                    <input type="text" name="lastname" class="form-control " :placeholder="t_last_name" required v-model="lastname">
                    <span v-if="inner_errors.hasOwnProperty('lastname')" class="help-block ">
                    <strong>{{ inner_errors['lastname'] }}</strong>
                </span>
                </div>
                <div :class="['form-group', inner_errors.hasOwnProperty('email') || inner_errors.hasOwnProperty('active') ? ' has-error' : '']">
                    <input type="email" name="email" class="form-control " :placeholder="t_email" required autofocus v-model="email">
                    <span v-if="inner_errors.hasOwnProperty('email')" class="help-block ">
                    <strong>{{ inner_errors['email'] }}</strong>
                </span>
                    <span v-if="inner_errors.hasOwnProperty('active')" class="help-block ">
                    <strong>{{ inner_errors['active'] }}</strong>
                </span>
                </div>
                <div :class="['form-group', inner_errors.hasOwnProperty('company') ? ' has-error' : '']">
                    <input type="text" name="company" class="form-control " :placeholder="t_company" v-model="company">
                    <span v-if="inner_errors.hasOwnProperty('company')" class="help-block ">
                    <strong>{{ inner_errors['company'] }}</strong>
                </span>
                </div>
                <div :class="['form-group', inner_errors.hasOwnProperty('phonenumber') ? ' has-error' : '']">
                    <input type="text" name="phonenumber" class="form-control " :placeholder="t_phonenumber" required v-model="phonenumber">
                    <span v-if="inner_errors.hasOwnProperty('phonenumber')" class="help-block ">
                    <strong>{{ inner_errors['phonenumber'] }}</strong>
                </span>
                </div>
                <template v-if="license_server_active">
                    <div class="form-group">
                        <select v-model="link" name="link" class="form-control  input-sm" style="font-size: 12px;">
                            <option value="0" style="font-size: 12px;">{{ t_no_link }}</option>
                            <option value="1" style="font-size: 12px;">{{ t_link_pk }}</option>
                            <option value="2" style="font-size: 12px;">{{ t_link_credentials }}</option>
                        </select>
                    </div>
                    <template v-if="link==='0'">
                        <div :class="['form-group', inner_errors.hasOwnProperty('spam-task') ? ' has-error' : '' ]">
                            <input type="text" name="spam-task" class="form-control" :placeholder="spam_task" required value="">
                            <span v-if="inner_errors.hasOwnProperty('spam-task')" class="help-block ">
                            <strong>{{ inner_errors['spam-task'] }}</strong>
                        </span>
                        </div>
                    </template>
                    <template v-else-if="link==='1'">
                        <div :class="['form-group', inner_errors.hasOwnProperty('productkey') ? ' has-error' : '']">
                            <input type="text" name="productkey" class="form-control animated" :placeholder="t_productkey + ': XXXXX-XXXXX-XXXXX-XXXXXX-XXXXXX'" required v-model="productkey">
                            <span v-if="inner_errors.hasOwnProperty('productkey')" class="help-block">
                            <strong>{{ inner_errors['productkey'] }}</strong>
                        </span>
                        </div>
                    </template>
                    <template v-else-if="link==='2'">
                        <div :class="['form-group license', inner_errors.hasOwnProperty('license_user') ? ' has-error' : '', !inited ? '' : '']">
                            <input type="text" name="license_user" class="form-control" :placeholder="t_license_user" required v-model="license_user">
                            <span v-if="inner_errors.hasOwnProperty('license_user')" class="help-block">
                            <strong>{{ inner_errors['license_user'] }}</strong>
                        </span>
                        </div>
                        <div :class="['form-group license', inner_errors.hasOwnProperty('license_password') ? ' has-error' : '', !inited ? '' : '']">
                            <input type="password" name="license_password" class="form-control" :placeholder="t_license_password" required v-model="license_password">
                            <span v-if="inner_errors.hasOwnProperty('license_password')" class="help-block">
                            <strong>{{ inner_errors['license_password'] }}</strong>
                        </span>
                        </div>
                    </template>
                </template>
                <v-btn id="register-submit" type="submit" class="btn btn-primary full-width">{{ t_register }}</v-btn>
                <div v-if="inner_errors.hasOwnProperty('general')" :class="['form-group', inner_errors.hasOwnProperty('general') ? ' has-error' : '']">
                <span class="help-block ">
                    <strong>{{ inner_errors['general'] }}</strong>
                </span>
                </div>
            </login-form>

            <login-window-footer :versionText="t_copyright">
                <a :href="url + '/sso/' + app_key">{{ t_login }}</a>
            </login-window-footer>
        </login-window>
        <login-footer-icons url="https://easescreen.com/"/>
    </login-container>
</template>

<script>
import Template from "../content/elements/template";
import LoginForm from "./login-form.vue";
import LoginWindow from "./login-window.vue";
import LoginFooterIcons from "./login-footer-icons.vue";
import LoginSubmitButton from "./login-submit-button.vue";
import LoginContainer from "./login-container.vue";
import LoginBanner from "./login-banner.vue";
import Loading from "../common/loading.vue";
import LoginEmailField from "./login-email-field.vue";
import LoginWindowFooter from "./login-window-footer.vue";
import LoginPasswordField from "./login-password-field.vue";
export default {
    name: "register-sso",
    components: {
        LoginPasswordField,
        LoginWindowFooter,
        LoginEmailField,
        Loading,
        LoginBanner,
        LoginContainer,
        LoginSubmitButton,
        LoginFooterIcons,
        LoginWindow,
        LoginForm,
        Template},
    props: [
        'apps',
        'version',
        'url',
        'app_key',
        'session',
        'errors',
        'license_server_active',
        'spam_task',
    ],
    data: function () {
        return {
            inner_apps: {
                app_key: {}
            },
            old: {},
            inner_errors: {},
            inner_session: {},
            link: '2',
            firstname: '',
            lastname: '',
            email: '',
            company: '',
            phonenumber: '',
            productkey: '',
            license_user: '',
            license_password: '',
            inited: false,

            t_sso_at: Lang.langGet("Single-Sign-On at"),
            t_success: Lang.langGet("The registration was successful.</br>Check your inbox, you should have received an email. There, you can set your password."),
            t_activated: Lang.langGet("The user was activated successfully.</br>You can close this window."),
            t_activated_previously: Lang.langGet("The user has already been activated previously!</br>You can close this window."),
            t_first_name: Lang.langGet('First name'),
            t_last_name: Lang.langGet('Last name'),
            t_email: Lang.langGet('Email address'),
            t_phonenumber: Lang.langGet("Phone number") + ": +43 000 1234567",
            t_company: Lang.langGet('Company'),
            t_register: Lang.langGet("Register"),
            t_login: Lang.langGet("Login"),
            t_copyright: Lang.langGet("easescreen Webinterface :version &copy; 2016 - :year", {"version": this.version, "year": new Date().getFullYear()}),
            t_no_link: Lang.langGet("Do not link with license portal"),
            t_link_pk: Lang.langGet("Use product key to link with license portal"),
            t_link_credentials: Lang.langGet("Use credentials to link with license portal"),
            t_productkey: Lang.langGet("Product Key"),
            t_license_user: Lang.langGet("License portal username"),
            t_license_password: Lang.langGet("License portal password"),
        }
    },
    provide() {
        return {
            appKey: this.app_key,
        }
    },
    watch: {
        link: function (val, oldVal) {
            if (oldVal !== val) {
                this.inited = true;
            }
        }
    },
    mounted: function () {
        this.inner_apps = JSON.parse(this.apps);
        this.inner_session = JSON.parse(this.session);

        this.inner_errors = {};
        var errors = JSON.parse(this.errors);
        Object.keys(errors).forEach((key) => {
            this.inner_errors[key] = Lang.langGet(errors[key][0]);
        });

        this.old = this.inner_session._old_input ?? [];
        this.link = this.old['link'] ?? '2';
        this.firstname = this.old['firstname'] ?? '';
        this.lastname = this.old['lastname'] ?? '';
        this.email = this.old['email'] ?? '';
        this.company = this.old['company'] ?? '';
        this.phonenumber = this.old['phonenumber'] ?? '';
        this.productkey = this.old['productkey'] ?? '';
        this.license_user = this.old['license_user'] ?? '';
        this.license_password = this.old['license_password'] ?? '';
    }
}
$(document).ready(function() {
    $('#form-register').on('submit', async function() {
        $('#register-submit').attr('disabled', true);
        $('#register-submit').attr('style', 'cursor: wait; opacity: 0.4 !important;');
    });
});
</script>
